import Vue from 'vue'
import Router from 'vue-router'
import auth from './auth'
import settings from './settings'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    auth,
    {
      path: '/',
      name: 'home',
      redirect: { name: 'users' },
      component: () => import(/* webpackChunkName: "home" */ '@/views/Home'),
      children: [
        {
          path: 'users',
          name: 'users',
          component: () =>
            import(/* webpackChunkName: "users" */ '@/views/Home/Users')
        },
        {
          path: 'users/invite',
          name: 'users.invite',
          component: () =>
            import(
              /* webpackChunkName: "user-invite" */ '@/views/Home/Users/InviteUser'
            )
        },
        // {
        //   path: 'users/add-site-owner',
        //   name: 'user.add.site-owner',
        //   component: () =>
        //     import(
        //       /* webpackChunkName: "add-user" */ '@/views/Home/Users/AddSiteOwner'
        //     )
        // },
        {
          path: 'users/:id',
          name: 'user.details',
          component: () =>
            import(
              /* webpackChunkName: "users" */ '@/views/Home/Users/UserDetails'
            )
        },
        {
          path: 'sites',
          name: 'sites',
          component: () =>
            import(/* webpackChunkName: "sites" */ '@/views/Home/Sites')
        },
        {
          path: 'sites/new',
          name: 'site.new',
          component: () =>
            import(
              /* webpackChunkName: "add-site" */ '@/views/Home/Sites/AddSite'
            )
        },
        {
          path: 'sites/:id',
          name: 'site.details',
          component: () =>
            import(
              /* webpackChunkName: "sites" */ '@/views/Home/Sites/SiteDetails'
            )
        },
        {
          path: 'boards',
          name: 'boards',
          component: () =>
            import(/* webpackChunkName: "boards" */ '@/views/Home/Boards')
        },
        settings
      ]
    }
  ]
})
